import React, { useRef } from 'react';

const path = '../oldPages/insert-management/detail/index.html';

function InsertManagementDetail() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  return <iframe ref={iframeRef} title="insert-management-detail" src={path} width="100%" height="1100px" />;
}

export default InsertManagementDetail;
